export default {"src":"/_next/static/media/star.77fac78c.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};